/**
 * 文件上传
 * Created by HeMengJiao on 2020/03/16.
 */
import axios from 'axios';
import AppConfig from '../appConfig';
import store from '../store/store';

//baseUrl
/*axios.defaults.baseURL = AppConfig.API.UPLOAD_URL;
//timeout
axios.defaults.timeout = 25000;
axios.defaults.headers['abgf'] = 'AUTH_TOKEN';*/

let setCookie = (c_name, value, expiredays) => {
  let exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = c_name + "=" + escape(value) + ";path=/"
    // + (AppConfig.API.DOMAIN_NAME ? ";domain=" + AppConfig.API.DOMAIN_NAME : "")
    + ((expiredays === null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/";
}
let delCookie = (name) => {
  let exp = new Date();
  exp.setTime(exp.getTime() - 1);
  let cval = getCookie(name);
  if (cval !== null) document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}
//获取Cookie
let getCookie = (name) => {
  let arr, reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  if (arr = document.cookie.match(reg)) {
    return (arr[2])
  } else {
    return null
  }
}

//默认设置token
let token = store.state.token ? store.state.token : ''
if (!token) {
  token = getCookie('token')
  if (token) {
    token = unescape(token)
  }
}
axios.defaults.headers['token'] = token;

//重置默认token
let resetToken = () => {
  let curToken = getCookie('token')
  if (curToken) {
    curToken = unescape(curToken)
  }
  if (token !== curToken) {
    token = curToken
  }
  axios.defaults.headers['token'] = token
}

export default {
  post(url, data) {
    resetToken()

    // qs.stringify(data)
    return axios({
      method: 'post',
      baseURL: AppConfig.API.BASE_URL_V3,
      url,
      data: data,
      timeout: 10000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8'
      }
    })
      .then((response) => {
        if (token && Number(response.data.code) === 20300) {
          //登录已失效，清除用户信息
          delCookie('token');
          delCookie('userInfo');
          store.commit('updateUserInfo', "");
          store.commit('updateToken', "");
          store.commit('updateCompany', "")
          store.commit('updateCompanyId', "")

          // console.log(url)
          // 跳转登录页
          let redirect = window.location.href
          window.location.href = AppConfig.API.MOBILE_V3 + '/login?redirect=' + redirect
        }

        return response
      })
      .catch((err) => {
        return err
      })
  },

  get(url, params) {
    resetToken()

    return axios({
      'method': 'get',
      baseURL: AppConfig.API.BASE_URL_V3,
      url,
      params, // get 请求时带的参数
      'timeout': 10000,
      'headers': {
        'X-Requested-With': 'XMLHttpRequest',
      }
    })
      .then((response) => {
        if (token && Number(response.data.code) === 20300) {
          //登录已失效，清除用户信息
          delCookie('token');
          delCookie('userInfo');
          store.commit('updateUserInfo', "");
          store.commit('updateToken', "");
          store.commit('updateCompany', "")
          store.commit('updateCompanyId', "")

          // 跳转登录页
          let redirect = window.location.href
          window.location.href = AppConfig.API.MOBILE_V3 + '/login?redirect=' + redirect
        }
        return response
      })
      .catch((err) => {
        return err
      })
  }
}



// WEBPACK FOOTER //
// ./src/factory-api/https-v3.js